import React from "react";
import { useNavigate } from "react-router-dom";
import aboutBanner from "../../images/about_banner.jpg";

/**
 * Shared page hero/banner matching Blogs & About Us:
 * - Same image (about_banner.jpg), font family (Segoe UI), and typography
 */
const PageBanner = ({ title, subtitle, backLabel, backPath, className = "" }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`relative w-full h-[280px] sm:h-[320px] md:h-[450px] overflow-hidden -mt-1 mb-8 md:mb-10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] ${className}`}
      style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
    >
      <img
        src={aboutBanner}
        alt=""
        className="absolute inset-0 w-full h-full object-cover brightness-[0.6]"
        aria-hidden
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-black/70 to-[#333]/50">
        {backPath && backLabel && (
          <button
            type="button"
            className="absolute top-4 left-4 md:top-6 md:left-6 px-4 py-2 rounded-lg bg-white/15 text-white text-sm font-semibold border border-white/40 hover:bg-white/25 hover:border-white/60 transition-colors"
            onClick={() => navigate(backPath)}
            aria-label={backLabel}
          >
            ← {backLabel}
          </button>
        )}
        <h1
          className="text-white text-2xl sm:text-3xl md:text-[3rem] font-black tracking-[2px] md:tracking-[3px] uppercase mb-2 drop-shadow-[2px_2px_4px_rgba(0,0,0,0.5)] text-center px-4"
          style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
        >
          {title}
        </h1>
        {subtitle && (
          <p
            className="text-white/95 text-base md:text-xl font-medium tracking-wide max-w-[500px] text-center px-4"
            style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageBanner;
